import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-multiplas-opcoes-dialog',
  templateUrl: './multiplas-opcoes-dialog.component.html',
  styleUrls: ['./multiplas-opcoes-dialog.component.scss']
})
export class MultiplasOpcoesDialogComponent implements OnInit {
  public disableContol = true;
  constructor(
    public dialogRef: MatDialogRef<MultiplasOpcoesDialogComponent>
  ) { }

  ngOnInit() {
  }

  automatica(){
    this.dialogRef.close("AUTOMATICO");
  }

  manual(){
    this.dialogRef.close("MANUAL");
  }

  checkValue(e) {
    if (e.currentTarget.checked === true) {
      this.disableContol = false;
    } else {
      this.disableContol = true;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/multiplas-opcoes-dialog/multiplas-opcoes-dialog.component.ts